export function resetAndClearPersistedPlugin(storage) {
  return ({ store }) => {
    store.resetAndClearPersisted = (id) => {
      store.$reset();
      storage.removeItem(id || store.$id);
    };
  };
}
